import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth18: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M190.5,64.2h0l-5.3,20.2-8.6,29.3-7.6,18.4c-111.8,29.8-153.4-7.2-153.4-7.2l-3.5-12.3-1.9-9.8-1.4-13.5-.2-14.5.4-9.8,3.1-9,7.5-11.5,11.3-9.2,11.3-3.9h20.3s11,2.1,11,2.1l12.9,4.5,6.1-3.5,7.8-3.5,8.4-1.9,10.3-1.2,9.8-1.2,11.3-1,9.6,1,11,3.1,11,4.7,9.8,5.9,8.4,7.8.7,15.9h-.1Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.1,76a14,14 0 1,1 -28,0a14,14 0 1,1 28,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M140.3,26.9l10.3.9,7.8,2.1,7.7,2.9,7.6,3.4,6.8,4.3,5.3,4.1,4,6.5v15.7s-11.5,37.9-11.5,37.9h-25.5c-14,0-12.4-17.5-12.4-17.5V27s0-.1,0-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M60.6,33.1h0l.2,60.6c0,13.8-13.6,11.3-13.6,11.3H11.9s-1.6-9.3-1.6-9.3l-1-8.2v-17.8s1.2-4.8,1.2-4.8l2.8-8.1,4.4-8,5.7-6,6.5-5.1,6.8-3.1,8.5-1.7,15.4.3h0Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.1,132.1h0l-2.9,7.7c-100,35.3-144.6-2.5-144.6-2.5l-6-12.5c52.2,37.2,153.4,7.2,153.4,7.2h.1Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.4,38.3h0c37.6,27.3,11.9,105.5,11.9,105.5,0,0,35.1-1.1,70.8-11.5l7.6-18.4,5.9-21.6,6.5-18.9,1.8-9.8v-7.6s-1-7.6-1-7.6l-8.4-7.8-9.8-5.9-11-4.7-11-3.1-9.6-1-21.1,2.1-18.7,3.1-13.9,7v.2Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M15.7,124.7h0c27.8,21.9,82.6,18.7,82.6,18.7,25.2-87.9-11.9-105.5-11.9-105.5l-12.9-4.5-11-2.1h-20.3s-11.3,3.9-11.3,3.9l-11.3,9.2-7.5,11.5-3.1,9-.4,9.8.2,14.5,1.4,13.5,1.9,9.8,3.5,12.3h.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'10.5 78.7 28.5 56.8 37.7 87.3 51 53.9 65.6 88.2 81.1 54.5 96.4 87.8 112.6 55.9 128 90.1 142.8 56.3 159.8 89 164.1 58.3 188.1 77.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'99.6 381.3 88.1 361.7 103.5 357.2 89.2 345.8 103.2 340.3 88.8 329.4 102.8 321.5 89.3 313.5 102.6 306 87.7 297.2 101.7 289.2 89.2 281.7 104.1 273.2 90.5 265.1 103.7 257.6 89.9 249.5 102.6 242.1 88.7 233.8 101.9 226.2 89.9 219.1 100.9 212.8 88.6 205.5 100.3 199 88 191.6 100.5 184.7 88.9 177.7 100.3 171.3 88.7 164.5 102.9 156.5 91.2 149.3 103.5 142.3 91.3 135 105.1 127.1 92.3 119.4 107.2 111 94.5 103.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'150.7 253.5 140.1 239 129.3 253.8 116.4 237.6 105.8 251.5 94 237.4 82.1 251.5 72.8 238.7 62.9 251.5 53.5 237.6 46.4 251.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.7,56.2h.4s1.8,7,1.8,7l1,7.6.2,15.1-3.1,24.2-2,9.7-4.2,12.1-5,10.3-5,11.5-5,9.7-3.1,4.4-2.4,2.6-3.4,3.4-3.4,3.2-4,2.9-5.7,2.2-8.4,2.3-4.2,1h-3.5s-7.8-.4-7.8-.4l-4.4.2-3.5-.2-5.7-.8-11.3-.6-7-1.6-6.7-1.3-4-.8-6.2-2.6-2.9-2-5.8-2.2-6.4-4.5-5.5-3.7-3.2-4.2-3.4-6.2-2.2-4-1.8-5.4-1.2-4-.4-5.8-.4-7.4.2-6.4.2-5.4,9.1-30s.6-5.5.6-6,.6-4,.6-4l1-7.8,1.6-2.9,1.4-3.7,1.3-2.2,3.4-3.5,4.9-4.4,5.2-4.5,7-3.9,4.5-2.4,5-2.2,5.7-1.4,3.9-.4h4.5s10.5-.2,10.5-.2l2.6-.6,3.7-1,5.5-1.6,3.7-1.3,4.9-1.3,2.6-1.2,4.9-1.4,2.9-.2s5.2-.4,6.4-.4,2.2.2,2.2.2l4.2.8,4.5,1,4.5,1.6,4,2,3.9,2.3,4.5,2.4,4,3.5,1.8,2,2,2.3,2.2,2.6,3.5,8h-.3Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154.7,150.6h0l-24.6-30.1c-14.5-21.7,9.4-37.2,9.4-37.2l29.6-27.1,2.7,10.3.9,10.5-.2,14-1.8,14.3-4.5,16.1-4,13.1-4.9,8.7-2.4,7.4h-.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.8,62.8h0l17.8,22.4,7.2,8.6c14.2,14.6-2.5,28.7-2.5,28.7l-2.5,2.2-32.2,25.5-3.2-15.7.2-15.1.5-7.2,2.9-10.6,6.3-16.2,1.1-6.1,1.1-10.4,3.4-6.1h-.1Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.1,34.2c-1.3,31.5,1.1,41.5,7.6,51.1,6.5,9.6,33.9-2,33.9-2l29.6-27.1-1.7-5.5-4.7-6.7-7.4-6.1-9.5-5.9-13.9-5-12.6.2-21.4,7h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98,34.1h0c-1.7,29.3,7.6,51.1,7.6,51.1,0,0-11.5-17.1-28.6,1.3-5.2,5.6-24.3-1.4-24.3-1.4l-17.8-22.4,3.2-7,5.4-5,7.2-5.2,8.6-4.7,10.1-3.4,9.5-1.4,12.1.5,7-2.3h0Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22.7,150.1h.2s32.2-25.5,32.2-25.5l9.5-4.3s-1.8,2.3-.4,7.4c1,3.4-4.9-1.2,8.9,14.5,13.8,15.6,11.7,42.6,11.7,42.6l-10-.9-12.3-2.3-14.8-5.9-11.6-7.4-8.6-9.8-4.8-8.4h0Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M84.7,184.8h.2c.6-29.9-11.7-42.6-11.7-42.6,0,0-15.2-13.6-8.5-21.9-.2,0,.6-3.1,9.4-3.1,8.8,0,8.6,7.5,18.3,7.5,9.7,0,13.9-9,22.3-9s15.7,4.8,15.7,4.8l24.6,30.1-8.2,14.9-7.4,8.3-10.8,8-14.2,3.1h-29.7,0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M139.6,83.2h0c-29.7,22.2-.6,43.9-9.4,37.2,0,0-8.6-4.8-15.7-4.8s-11.4,9-22.3,9c-10.9,0-15-7.5-18.3-7.5s-19,7.5-19,7.5l2.5-2.2c20.2-18.4-7.1-37.3-4.7-37.3s18.2,8.6,24.3,1.4c6.1-7.2,19-14.6,28.6-1.3,6.6,9.2,33.9-2,33.9-2h.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'167.3 112.2 148.9 90.7 144.4 123.7 129.9 84.3 118.8 123.7 105.4 82.2 92.8 121.2 79.3 82.2 67.3 121.7 54.2 82.2 44.3 120.7 36.7 89.3 22.4 112.7',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.9,372.2h.3c92.4-17.7,156,14.6,156,14.6l14.1,33.3,3.6,15.5.8,9.2-1,9.4-3.4,9-9.2,8.2-15.3,5-15.1,3.4-25.6-.2-18-5.7h-12s-21.3,3.6-21.3,3.6l-12-.2-6.3-.4-11.5-2.7-7.5-3.8-5.7-4.8-4.6-7.5-2.9-8.4-1.5-6.5-4.6-5.8-2.5-7.1-1.5-6.7-.7-7.5.8-7.9,1.7-13,1.2-10.5,3.8-12.4h-.1Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M171.1,387h0l-4.3-9.8c-65.9-36.4-149.3-12.5-149.3-12.5l-2.5,7.7c92.9-17.7,156,14.6,156,14.6h.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.6,417.2a13.1,13.1 0 1,1 -26.2,0a13.1,13.1 0 1,1 26.2,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M177.7,405.2h0l7.5,17,3.8,15.8-.7,15.8-3.8,9.2-7.4,6.9-13.6,5.8-19.4,4.2-13.4-.2v-63c0-9.8,9.2-11.3,9.2-11.3h37.7s.1-.2.1-.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M9.1,405h0l-1.7,5.7v13s3.1,11.3,3.1,11.3l5.7,7.9,2.7,10.5,4.6,9.4,7.5,7.5,9,4,22.8,3.4s.7-53.8.7-62c0-8.2-9.6-10.7-9.6-10.7H9.1s0,0,0,0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M92.7,473.8h-.2s-4.9-48.7-15.5-64.5c-10.4-15.8-2.7-42.1-2.7-42.1-26.1-1.3-59.4,5.2-59.4,5.2l-5.1,17.2-2.3,18.4v13.9s2.7,12.5,2.7,12.5l6.3,9.8,1.5,7.7,3.8,8.6,6.3,8.2,11.3,5.7,13.9,3.1h12.7s14.2-2.1,14.2-2.1l12.4-1.7h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M171.1,387h0c-44.4-20.7-96.7-19.9-96.7-19.9,0,0-7.6,26,2.7,42.1,10.8,16.9,15.5,64.5,15.5,64.5l9.3.4,18,5.7,25.6.2,15.1-3.4,15.3-5,9.2-8.2,3.4-9,1-9.4-.8-9.2-3.6-15.5-14.1-33.3h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'186.9 431.1 163.4 406.9 158.4 443.6 140.4 400.1 127.9 444 111.1 398.2 96.7 441.6 79.9 398.6 66 442.4 49.9 398.9 38.5 441.6 29.1 406.7 12.5 431.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'67.3 371.1 78 362.9 63.7 356.8 74.5 348.5 61.3 342.8 71.6 334.9 59.7 329.8 69.7 322.2 56 316.3 65.9 308.9 54.9 304.2 64.8 296.7 52.8 291.7 63.2 283.8 52 279 62.4 271.1 51.8 266.5 62 258.9 49.3 253.5 61.1 244.5 47.1 240.4 59 232.1 45.8 227 55.7 217.6 43.7 212.7 51.4 203 38.7 199.9 51.5 189.4 37.2 185.7 46.8 173 34.1 170.3 38 154.8',
				'121.6 145.6 118.5 161.8 130.8 162.2 123.1 174.1 136.2 179.5 127 189.1 140.1 194.1 128.1 203 140.1 208.4 128.1 216.1 140.1 221.7 127.9 228.1 140.2 235.9 128.4 242.3 140.9 250.3 128.7 256.7 139.4 263.6 129.2 269 140.2 276 129.4 281.6 140.3 288.7 128.8 294.7 139.2 301.4 128.6 306.9 139 313.5 125.8 320.4 136.3 327.2 124.9 333.2 136.5 341.7 123 347 133.9 356 120.7 361.7 132.4 372.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'159.4 263.9 145.7 246.9 132.8 264.4 117.1 245.6 104 264.3 93.5 245.7 80.3 263.7 66.5 246.7 57 264.3 41.7 246.5 33.4 262.7',
			],
		},
	},
};
